exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container.form-wrapper[data-v-06066610]{position:relative}", ""]);

// exports
